export default __webpack_public_path__ + "static/media/11.df6fe7bc.jpg";